import { BaseApi } from "../../utils/BaseApi";
import { HttpMethodEnum } from "../models/HttpMethodEnum";
import { TravelBookingRequest, TravelBookingStatus } from "../models/Experience/ExperienceModels";
import {
  AdminCompany,
  AdminCompanyEncryptionData,
  AdminCompanyEncryptionDecryptResult,
  AdminCompanyInput,
  AdminCompanyUpdateInput,
  AdminBillingPlan,
  AdminBillingPlanInput,
  AdminPaymentGateway,
  AdminPaymentGatewayInput,
  AdminUser,
  AdminUserInput,
  AdminUserPasswordInput,
  AdminUserUpdateInput,
} from "../models/Admin/AdminModels";

class AdminApi extends BaseApi {
  public listTravelRequests = BaseApi.createEndpoint<TravelBookingRequest[], null>(HttpMethodEnum.GET, "/admin/travel/requests");
  public updateTravelRequestStatus = (companyId: string, bookingId: string) =>
    BaseApi.createEndpoint<TravelBookingRequest, { status: TravelBookingStatus }>(HttpMethodEnum.PUT, `/admin/travel/requests/${encodeURIComponent(companyId)}/${encodeURIComponent(bookingId)}/status`);
  public listCompanies = BaseApi.createEndpoint<AdminCompany[], null>(HttpMethodEnum.GET, "/admin/companies");
  public createCompany = BaseApi.createEndpoint<AdminCompany, { company: AdminCompanyInput }>(HttpMethodEnum.POST, "/admin/companies");
  public updateCompany = (companyId: string) =>
    BaseApi.createEndpoint<AdminCompany, { company: AdminCompanyUpdateInput }>(HttpMethodEnum.PUT, `/admin/companies/${companyId}`);
  public validateCompanyWhatsApp = (companyId: string) =>
    BaseApi.createEndpoint<{ whatsapp?: unknown }, null>(HttpMethodEnum.POST, `/admin/companies/${companyId}/whatsapp/validate`);
  public updateCompanyBilling = (companyId: string) =>
    BaseApi.createEndpoint<AdminCompany, { billing: AdminCompanyInput["billing"] }>(HttpMethodEnum.PUT, `/admin/companies/${companyId}/billing`);
  public deleteCompany = (companyId: string) =>
    BaseApi.createEndpoint<boolean, null>(HttpMethodEnum.DELETE, `/admin/companies/${companyId}`);
  public listBillingPlans = BaseApi.createEndpoint<AdminBillingPlan[], null>(HttpMethodEnum.GET, "/admin/billing/plans");
  public createBillingPlan = BaseApi.createEndpoint<AdminBillingPlan, { plan: AdminBillingPlanInput }>(HttpMethodEnum.POST, "/admin/billing/plans");
  public updateBillingPlan = (planId: string) =>
    BaseApi.createEndpoint<AdminBillingPlan, { plan: AdminBillingPlanInput }>(HttpMethodEnum.PUT, `/admin/billing/plans/${planId}`);
  public deleteBillingPlan = (planId: string) =>
    BaseApi.createEndpoint<boolean, null>(HttpMethodEnum.DELETE, `/admin/billing/plans/${planId}`);
  public listPaymentGateways = BaseApi.createEndpoint<AdminPaymentGateway[], null>(HttpMethodEnum.GET, "/admin/billing/gateways");
  public updatePaymentGateway = (provider: string) =>
    BaseApi.createEndpoint<AdminPaymentGateway, { gateway: AdminPaymentGatewayInput }>(HttpMethodEnum.PUT, `/admin/billing/gateways/${provider}`);
  public encryptCompanyId = BaseApi.createEndpoint<AdminCompanyEncryptionData, { idMapos: string }>(
    HttpMethodEnum.POST,
    "/admin/company-encryption/encrypt",
  );
  public decryptCompanyId = BaseApi.createEndpoint<
    AdminCompanyEncryptionDecryptResult,
    AdminCompanyEncryptionData
  >(HttpMethodEnum.POST, "/admin/company-encryption/decrypt");
  public listUsers = BaseApi.createEndpoint<AdminUser[], null>(HttpMethodEnum.GET, "/admin/users");
  public createUser = BaseApi.createEndpoint<AdminUser, { user: AdminUserInput }>(HttpMethodEnum.POST, "/admin/users");
  public updateUser = (userId: string) =>
    BaseApi.createEndpoint<AdminUser, { user: AdminUserUpdateInput }>(HttpMethodEnum.PUT, `/admin/users/${userId}`);
  public deleteUser = (userId: string) =>
    BaseApi.createEndpoint<boolean, null>(HttpMethodEnum.DELETE, `/admin/users/${userId}`);
  public updateUserPassword = (userId: string) =>
    BaseApi.createEndpoint<boolean, AdminUserPasswordInput>(HttpMethodEnum.PUT, `/admin/users/${userId}/password`);
}

export const adminApi = new AdminApi();
